module.exports = __webpack_public_path__ + "media/images/emblems/Hinwil-blazon-7ab3a4e27dfb51a14d746c503e0eaa8a.svg";